// removed by extract-text-webpack-plugin
module.exports = {"button":"styles__button___2scXF","buttonCol":"styles__buttonCol___1vbIY","buttonRow":"styles__buttonRow___3PKF8","rotate":"styles__rotate___3ALVu","fadein":"styles__fadein___2KVic","slideFromRight":"styles__slideFromRight___1mn-d","waves":"styles__waves___3D7jB"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/SocialMedia/styles.scss
// module id = ./resources/assets/js/components/SocialMedia/styles.scss
// module chunks = 0